var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app flex-row auth-page"},[_c('div',{staticClass:"auth-clear-state"},[_c('div',{staticClass:"auth-clear-card"},[_c('AppIcon',{attrs:{"name":"delete","font-scale":"1.5"}}),_c('strong',[_vm._v("Limpiando caché")]),_c('span',[_vm._v("Preparando una sesión limpia…")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }